export type CiscoMac = `${string}.${string}.${string}`;
export type IsoMac =
  `${string}:${string}:${string}:${string}:${string}:${string}`;
export type AnyMac = CiscoMac | IsoMac;
